import { render, staticRenderFns } from "./allTopic.vue?vue&type=template&id=97e1cbaa&scoped=true&"
import script from "./allTopic.vue?vue&type=script&lang=js&"
export * from "./allTopic.vue?vue&type=script&lang=js&"
import style0 from "./allTopic.vue?vue&type=style&index=0&id=97e1cbaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e1cbaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e1cbaa')) {
      api.createRecord('97e1cbaa', component.options)
    } else {
      api.reload('97e1cbaa', component.options)
    }
    module.hot.accept("./allTopic.vue?vue&type=template&id=97e1cbaa&scoped=true&", function () {
      api.rerender('97e1cbaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/allTopic.vue"
export default component.exports